module.exports = __webpack_public_path__ + "static/media/Checkmark.7134c694.svg";